import { createParser } from './create.js';
import config from '../syntax/config/parser-selector.js';

export default createParser(config);
